import script from "./Cookie_Policy.vue?vue&type=script&setup=true&lang=js"
export * from "./Cookie_Policy.vue?vue&type=script&setup=true&lang=js"

import "./Cookie_Policy.vue?vue&type=style&index=0&id=05108f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05108f18"]])

export default __exports__